import React from "react";
import Layout from "../components/Layout";

const About = () => (
  <Layout>
    <h1>About Page</h1>
    <p>This is the About page. Add your content here.</p>
  </Layout>
);

export default About;
